import './src/styles/index.scss';
import './src/utils/init-is-tabbing';
